module.exports = __webpack_public_path__ + "static/media/Trendsetter.408d9cb5.jpg";